export const CONTRACTS: {
  [chainId: number]: { [key: string]: string };
} = {
  84531: {
    fantech: "0x7CD936077b99204DDf84A2E6054F26512CaA9c84",
  },
  8453: {
    fantech: "0x236bb8E06caFDd279E5AdCcA7cF201ebf4ed0eff",
  },
};
